import { cn } from '@/lib/utils';

/** A seller's photo, square and cropped to fill, with its name as the text
 *  alternative. */
export const SellerPhoto = ({ src, name, className }: { src: string; name: string; className?: string }) => (
  <img
    src={src}
    alt={name}
    loading="lazy"
    className={cn('aspect-square shrink-0 rounded-10 border border-rule bg-surface-2 object-cover', className)}
  />
);
